export default __webpack_public_path__ + "static/media/IMG_5747.6b42e9d4.jpg";